
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./../bootstrap');

const Vue = require('vue');

window.Vue = Vue;

import vSelect from 'vue-select';

import Multiselect from 'vue-multiselect';

import Treeselect from '@riophae/vue-treeselect';

import Snotify, { SnotifyPosition } from 'vue-snotify';


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const options = {
    toast: {
        timeout: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.rightTop
    }
};


Vue.use(Snotify, options);

Vue.component('treeselect', Treeselect);

Vue.component('v-select', vSelect);

Vue.component('multiselect', Multiselect);


/* crm vue components start */
Vue.component('crm-contact-request', require('./components/crm/contacts/request/create.vue'));
Vue.component('modal', require('./components/modal.vue'));
/* crm vue components end */

Vue.mixin({

    methods: {

        replaceObjProperty : function(obj, searchProperty = 'name', replaceWithProperty = 'label') {
            let self = this;
            let newObj = {
                'children': []
            };

            _.forEach(obj, function (value, key) {
                if (key ==  searchProperty) {
                    newObj['label'] = value;
                } else if (key == 'children' && obj[key].length) {
                    _.forEach(obj[key], function (child) {
                        newObj.children.push(self.replaceObjProperty(child, searchProperty, replaceWithProperty));
                    });
                } else {
                    newObj[key] = value;
                }
            });

            if (newObj.children.length === 0) {
                delete newObj.children;
            }

            return newObj;
        }
    }
});


const app = new Vue({
    el: '#app',
    data: {
        showModal: false
    }
});

export default app;



// WEBPACK FOOTER //
// ./resources/assets/js/external/app.js